"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

require("whatwg-fetch");

var usePushProsScripts = function usePushProsScripts(ppUrl) {
  (0, _react.useEffect)(function () {
    (function () {
      window.fetch(ppUrl + window.location.hostname, {
        method: 'GET',
        redirect: 'follow',
        mode: 'cors'
      }).then(function (r) {
        r.json().then(function (response) {
          console.log('response pushpros', response);
          if (!response.success || !response.script) return;
          var s = document.createElement("script");
          s.type = "text/javascript";
          s.innerHTML = response.script;
          document.getElementsByTagName('head')[0].appendChild(s);
        });
      });
    })();

    return; // eslint-disable-next-line
  }, []);
};

var _default = usePushProsScripts;
exports.default = _default;

//# sourceMappingURL=usePushProsScripts.js.map